import React from "react";
import { FaFileAlt } from "react-icons/fa";

export default function LegalDocumentView({ document }) {
  if (!document) {
    return <div className="text-center py-8">Document not found</div>;
  }

  const { name, content, documentUrl, createdAt, updatedAt } = document;

  return (
    <div className="border-t border-mediumgray">
      <dl>
        <div className="bg-lightergray px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-darkgray">Document Name</dt>
          <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">{name}</dd>
        </div>

        {documentUrl && (
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-darkgray">
              Document File
            </dt>
            <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">
              <a
                href={documentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:underline"
              >
                <FaFileAlt className="mr-2" />
                View Document
              </a>
            </dd>
          </div>
        )}

        <div className="bg-lightergray px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-darkgray">Content</dt>
          <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">
            <div className="max-h-96 overflow-y-auto border rounded-md p-3 bg-white">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </dd>
        </div>

        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-darkgray">Created Date</dt>
          <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">
            {new Date(createdAt).toLocaleString("en-AU", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </dd>
        </div>

        <div className="bg-lightergray px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-darkgray">Last Updated</dt>
          <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">
            {new Date(updatedAt).toLocaleString("en-AU", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </dd>
        </div>
      </dl>
    </div>
  );
}